import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";

export default class WorkScheduleSettingsModule extends SettingsModule {
    constructor() {
        super({
            name                     : "Work Schedule",
            description              : "The Work Schedule module provides a streamlined solution for managing and organizing work schedules within your workspace.",
            svgIcon                  : "isvg-work-schedule",
            settingsUrl              : "settings/work-schedule",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            // typeLabel                : "Company users"
        });

        this.parentSection          = SettingsParentSection.COMPANY_USERS

        this.hasStatus              = false
    }

}
